module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--6--create-513f9703.jpg";